import { render, staticRenderFns } from "./IntroSelfRegistration.vue?vue&type=template&id=481bf00e&scoped=true&"
import script from "./IntroSelfRegistration.vue?vue&type=script&lang=js&"
export * from "./IntroSelfRegistration.vue?vue&type=script&lang=js&"
import style0 from "./IntroSelfRegistration.vue?vue&type=style&index=0&id=481bf00e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bf00e",
  null
  
)

export default component.exports